import { render, staticRenderFns } from "./wty-userGroup.vue?vue&type=template&id=30bfebbe&scoped=true&"
import script from "./wty-userGroup.vue?vue&type=script&lang=js&"
export * from "./wty-userGroup.vue?vue&type=script&lang=js&"
import style0 from "./wty-userGroup.vue?vue&type=style&index=0&id=30bfebbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfebbe",
  null
  
)

export default component.exports